export const VideoBanner = () => {
  const videoUrl = 'https://sidepost-app-files-dev.s3.amazonaws.com/videos/sidepost.mp4';

  return <video muted autoPlay loop>
    <source src={videoUrl} type="video/mp4" />
  </video>
}